var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M22.9 26.1c-.3 0-.5-.1-.7-.3l-4.1-4.1-4 4c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4.7-4.7c.2-.2.4-.3.7-.3.3 0 .5.1.7.3l4.1 4.1 4.4-4.4c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5.1 5.1c-.2.2-.4.3-.7.3z" }),
    React.createElement("circle", { className: styles["oc-icon-product"] || "oc-icon-product", cx: "28", cy: "20.1", r: "2" }),
    React.createElement("circle", { className: styles["oc-icon-product"] || "oc-icon-product", cx: "18.1", cy: "20.4", r: "2" }),
    React.createElement("circle", { className: styles["oc-icon-product"] || "oc-icon-product", cx: "22.9", cy: "25.1", r: "2" }),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M29.7 33.7H9.2c-.8 0-1.5-.7-1.5-1.5v-22c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v20.6h19c.8 0 1.5.7 1.5 1.5 0 .7-.7 1.4-1.5 1.4z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Liquidity.svg